var Register = {};

//--------------
// Variables
//--------------
Register.wrapper = '.js-register';
Register.form = '.js-form-register';
Register.formWrapper = '.js-form-wrapper';

//--------------
// Methods
//--------------

/**
 * [changeStep description]
 * @param  {[type]} toStep      [description]
 * @param  {[type]} currentStep [description]
 * @return {[type]}             [description]
 */
Register.changeStep = async function (toStep, currentStep) {
    // Validate form
    if (currentStep) {
        if (!$(Register.form).valid()) {
            return false;
        }
    }

    // Check if email doesnt exists
    if (currentStep == 1) {
        Register.checkEmail($('#account_email').val(), function (data) {
            if (data.success === false) {
                alert(data.datas.message);
            } else {
                Register.goToStep(toStep);
            }
        });
        return false;
    }

    // Check address again when it confirmed
    if (currentStep == 2) {
        Register.checkPostcode($('#address').attr('data-postcode'), function (data) {
            if (!data.canBeDelivered) {
                alert('There is an issue with the address. Please check that you have selected an address from the dropdown or that the address you entered is in our delivery area.');
            } else {
                Register.goToStep(toStep);
            }
        });
        return false;
    }

    // Go back
    if (!currentStep) {
        $('.js-step[data-step="' + toStep + '"]').removeClass('is-checked');
    }

    // Go to last step
    if (toStep == 4) {
        $('.js-step').addClass('is-checked');
        Register.setDatas();
    }

    // Change step
    Register.goToStep(toStep);
}

Register.getCurrentStep = function () {
    return parseInt($('.js-step.is-active').attr('data-step'), 10);
}

/**
 * [goToStep description]
 * @param  {[type]} step [description]
 * @return {[type]}      [description]
 */
Register.goToStep = function (step) {
    // Change step
    $(Register.formWrapper).hide();
    $(Register.formWrapper + '[data-step="' + step + '"]').show();
    $('.js-step').removeClass('is-active');
    $('.js-step[data-step="' + step + '"]').addClass('is-active');
    $('.js-step[data-step="' + step + '"]').prevAll().addClass('is-checked');
}

/**
 * [getGiftExp description]
 * @return {[type]} [description]
 */
Register.getRegisterAccount = function () {
    var account = {};
    account.firstname = $('#account_firstname').val();
    account.lastname = $('#account_lastname').val();
    account.phone = $('#account_phone').val();
    account.email = $('#account_email').val();
    account.confirm_email = $('#account_confirm-email').val();
    account.password = $('#account_password').val();
    account.password_confirm = $('#account_password_confirm').val();

    return account;
}

/**
 * [getGiftDest description]
 * @return {[type]} [description]
 */
Register.getRegisterAddress = function () {
    var address = {};
    address.postcode = $('#postcode').val();
    address.latitude = $('#address').attr('data-latitude');
    address.longitude = $('#address').attr('data-longitude');
    address.thoroughfare = $('#address').attr('data-thoroughfare');
    address.building_type = $('#address_building-type option:selected').attr('value');
    address.building_name = $('#address').attr('data-building-name');
    address.building_number = $('#address').attr('data-building-number');
    address.sub_building_name = $('#address').attr('data-sub-building-name');
    address.sub_building_number = $('#address').attr('data-sub-building-number');
    address.line_1 = $('#formatted_address_0').val();
    address.line_2 = $('#formatted_address_1').val();
    address.line_3 = $('#formatted_address_2').val();
    address.city = $('#town_or_city').val();
    address.country_code = $('#address').attr('data-country-code');
    address.comment = $('#address_comments').val();

    return address;
}

/**
 * [getGift description]
 * @return {[type]} [description]
 */
Register.getRegisterCard = function () {
    var card = {};
    card.cardholder = $('#cardholder-name').val();
    card.number = $('#card-number').val();
    card.expire_date = $('#card_expiry-date').val();
    card.cvc = $('#card_cvc').val();

    return card;
}

/**
 * [getNotifications description]
 * @return {[type]} [description]
 */
Register.getNotifications = function () {
    var notifications = {};
    notifications.terms = $('#terms-checkbox').html();
    notifications.newsletter = $('#newsletter').is(':checked') ? 1 : 0;
    notifications.special_offers = $('#special_offers').is(':checked') ? 1 : 0;

    return notifications;
}

/**
 * [setDatas description]
 */
Register.setDatas = function () {
    var user = Register.getRegisterAccount();
    var address = Register.getRegisterAddress();
    var card = Register.getRegisterCard();

    $('.js-register-summary .js-firstname').html(user.firstname);
    $('.js-register-summary .js-lastname').html(user.lastname);
    $('.js-register-summary .js-phone').html(user.phone);
    $('.js-register-summary .js-email').html(user.email);

    $('.js-address-1 .data__input').html(address.line_1);
    if (address.line_2) { $('.js-address-2 .data__input').html(address.line_2); } else { $('.js-address-2 ').hide();}
    if (address.line_3) { $('.js-address-3 .data__input').html(address.line_3); } else { $('.js-address-3 ').hide();}
    $('.js-postcode .data__input').html(address.postcode);
    $('.js-building-type .data__input').html(address.building_type);
    if (address.comment) { $('.js-comment .data__input').html(address.comment); } else { $('.js-comment ').hide(); }

    if (card.number) { $('.register-card').show(); } else { $('.register-card').hide(); }
    $('.js-register-summary .js-card-holder').html(card.cardholder);
    $('.js-register-summary .js-card-number').html('**** **** **** ' + card.number.substr(card.number.length - 4));
    $('.js-register-summary .js-card-expire-date').html(card.expire_date);
    $('.js-register-summary .js-card-cvc').html('***');
}

/**
 * [error description]
 * @return {[type]} [description]
 */
Register.error = function () {
    // $('.js-form-commande .js-form-message-success').hide();
    // $('.js-send-by-wrapper').fadeOut();
    // $('.js-steps-wrapper').addClass('opacity-0');
    // $('.js-form-messages-wrapper').fadeIn();
    // Register.goToTopFormMessage();
    // App.errorMessage('.js-form-commande');
};

/**
 * [sendRegister description]
 * @param  {[type]} user      [description]
 * @param  {[type]} address   [description]
 * @param  {[type]} card        [description]
 */
Register.sendRegister = function (user, address, card, notifications) {
    $('.js-prev-step').hide();
    $('.js-register-valid').hide();
    $('.loading-text').remove();
    $('.popup-loader').removeClass('d-none');

    let data = {
        firstname: user.firstname,
        lastname: user.lastname,
        phone: user.phone,
        email: user.email,
        email_confirmation: user.email,
        password: user.password,
        password_confirmation: user.password,
        address: address,
        terms: notifications.terms,
        newsletter: notifications.newsletter,
        special_offers: notifications.special_offers
    };

    if (card.number) {
        data.cardholder = card.cardholder;
        data.number = card.number;
        data.exp_month = card.expire_date.substring(0, 2);
        data.exp_year = card.expire_date.substring(3, 5);
        data.cvc = card.cvc;
    }


    $.post({
        url: '/account/register',
        type: 'POST',
        headers:{
            Accept: "application/json",
        },
        data: data
    }).done(function (data) {
        if (typeof fbq === "function") {
            fbq('track', 'CompleteRegistration');
        }
        window.location.href = '/email/verify';
    }).fail(function (err) {
        $('.popup-loader').addClass('d-none');
        if (err.message) {
            alert(err.message);
            $('.js-register-valid').show();
            $('.js-prev-step').show();
            $('.loading-text').remove();
            Register.goToStep(3);
        } else {
            console.error(err);
        }
    });
}

/**
 * [checkEmail description]
 * @param  {[type]}   postcode [description]
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
Register.checkEmail = function (email, callback) {
    $.post({
        url: '/account/register/email',
        type: 'POST',
        data: {email: email}
    }).done(function (data) {
        callback(data);
    }).fail(function (err) {
        console.log(err);
    });
}

/**
 * [checkPostcode description]
 * @param  {[type]}   postcode [description]
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */
Register.checkPostcode = function (postcode, callback) {
    $.post({
        url: '/account/register/postcode',
        type: 'POST',
        data: {postcode: postcode}
    }).done(function (data) {
        if (typeof fbq === "function") {
            fbq('trackCustom', 'CheckPostcode');
        }
        callback(data);
    }).fail(function (err) {
        console.log(err);
    });
}


//--------------
// Execution
//--------------

// Order Form Valdate
$(Register.form).validate({
    // rules: {
    //     commande_montant: {
    // 	    // required: true,
    // 	    number: true
    //     }
    // },
    errorPlacement: function (error, element) {
        error.insertBefore(element);
    }
});


// Go to next step
$('.js-next-step').click(function () {
    var currentStep = $(this).closest(Register.formWrapper).data('step');
    var toStep = $(this).data('next');

    if ($(this).hasClass('js-skip')) {
        $('#cardholder-name').val('');
        $('#card-number').val('');
        $('#card_expiry-date').val('');
        $('#card_cvc').val('');

        Register.changeStep(toStep, null);
    } else {
        Register.changeStep(toStep, currentStep);
    }
});

// Go to prev step
$('.js-prev-step').click(function () {
    var toStep = $(this).data('prev');

    Register.changeStep(toStep, null);
});


//-- Send postcode check form
$('.js-register-postcode').submit(function () {

    if ($(this).valid()) {
        Register.checkPostcode($('#register-postcode').val(), function (data) {
            window.location.href = data.redirectUrl;
        });
    }

    return false;
});

//--  Send register form
$(Register.form).submit(function () {
    const currentStep = Register.getCurrentStep();
    if (currentStep <= 3) {
        const toStep = currentStep + 1;
        Register.changeStep(toStep, currentStep);
        return false;
    }

    const user = Register.getRegisterAccount();
    const address = Register.getRegisterAddress();
    const card = Register.getRegisterCard();
    const notifications = Register.getNotifications();

    if ($(this).valid()) {
        Register.sendRegister(user, address, card, notifications);
    }

    return false;
});


module.exports = Register;
